import * as XLSX from 'xlsx';
import { I18n } from 'react-redux-i18n';
import { describePatchChange } from './patchChangeDescription';
import { downloadWorkbook, toFileNameFragment } from './xlsxDownload';

// Mêmes colonnes que la vue "déplier", dans le même ordre : le fichier doit se
// relire comme l'écran dont il sort. id_zone n'apparaît qu'en multi-zones, et
// seulement pour les vues issues de draft_synchro.
const COLUMNS = ['type', 'id_table', 'crud', 'field', 'value', 'old_value'];
const ZONE_COLUMN = 'id_zone';

// Largeurs en caractères, indexées comme les colonnes. La description est la
// seule destinée à être lue, les autres ne servent qu'à retrouver la ligne
// d'origine.
const DESCRIPTION_WIDTH = 70;
const ZONE_WIDTH = 12;
const COLUMN_WIDTHS = [22, 22, 10, 16, 40, 40];

/**
 * Nom d'onglet accepté par Excel : 31 caractères au plus, et sans les signes
 * qu'il réserve aux références de plage. La liste diffère de celle des noms de
 * fichier, d'où un nettoyage distinct.
 * @param {String} label
 * @returns {String}
 */
function toSheetName(label) {
	const cleaned = String(label || '')
		.replace(/[\\/:*?[\]]/g, '-')
		.trim()
		.slice(0, 31);
	return cleaned || 'Export';
}

/**
 * Construit et télécharge l'export XLSX d'un lot de modifications.
 *
 * La description est calculée ici, avec le même utilitaire que l'affichage :
 * la traduire côté serveur en dupliquerait toute la logique, et le fichier
 * pourrait alors dire autre chose que l'écran.
 *
 * @param {Object} params
 * @param {Array<Object>} params.rows lignes brutes, telles que rendues par l'API
 * @param {Object} params.entities produits, catégories… pour nommer les entités
 * @param {String} params.label intitulé du lot (nom du stash ou du déploiement)
 * @param {String} params.filename nom du fichier, extension comprise
 * @param {Boolean} [params.showZone] ajoute la colonne id_zone
 */
export function exportChanges({ rows, entities, label, filename, showZone }) {
	const columns = showZone ? [ZONE_COLUMN, ...COLUMNS] : COLUMNS;
	const widths = showZone
		? [DESCRIPTION_WIDTH, ZONE_WIDTH, ...COLUMN_WIDTHS]
		: [DESCRIPTION_WIDTH, ...COLUMN_WIDTHS];

	const header = [I18n.t('deploy.history.colDescription'), ...columns];

	const body = rows.map(row => [
		describePatchChange(row, entities),
		...columns.map(column => {
			const value = row[column];
			// null et undefined donneraient une cellule portant le texte
			// « null » ; une valeur absente doit rester une cellule vide.
			return value === null || value === undefined ? '' : String(value);
		}),
	]);

	const worksheet = XLSX.utils.aoa_to_sheet([header, ...body]);
	worksheet['!cols'] = widths.map(width => ({ wch: width }));

	const workbook = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(workbook, worksheet, toSheetName(label));

	downloadWorkbook(workbook, filename);
}
